<div class="UNFAPP-score-rank-graph">
<div id="racecourse"></div>
<div class="UNFAPP-score-mark-label-row">
    <ul class="UNFAPP-score-mark-label-list">
        <li>
            <img src="assets/img/lowest-red-arrow.svg" class="low"><span>Low <b>{{testRecord?.lowestScore}}</b></span>
        </li>
        <li>
            <img src="assets/img/star-purple.svg" class="high"><span>High <b>{{testRecord?.highestScore}}</b></span>
        </li>
        <li>
            <img src="assets/img/cutoff-icon.svg" class="cutoff"><span>Cutoff <b>{{ testRecord?.newCutoff||testRecord?.cutoffScore || 0}}</b></span>
        </li>
    </ul>
</div>
</div>
<div class="UNFAPP-score-whitetbx UNFAPP-equalizer-box score-box data-box">
    <div class="row justify-content-between">
        <div class="col-lg-4">
            <div class="UNFAPP-equalizer-data">
                <img src="assets/img/star-purple.svg" class="icon" />
                <span>: Highest Score achieved in test</span>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="UNFAPP-equalizer-data">
                <img src="assets/img/lowest-red-arrow.svg" class="icon" />
                <span>: Lowest Score achieved in test</span>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="UNFAPP-equalizer-data">
                <img src="assets/img/flag-sm-icon.svg" class="icon" />
                <span>: Max Score possible in the test</span>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="UNFAPP-equalizer-data">
                <img src="assets/img/scissor.svg" class="icon" />
                <span>: {{testRecord?.examtype == 1 ?'NEET':testRecord?.examtype == 3 ?'JEE Advance' : examType}} Cutoff</span>
            </div>
        </div>

    </div>
</div>